import { appConfig } from './appConfig'

export const firebaseConfig = appConfig.firebase
